// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mCVX7","title":"styles_title__1Nnuo"};